import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../logging/logging.service';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { CourierServiceResponse, PackageOptionResponse } from '../../models/inModels/MarketPlaceModel';

@Injectable()
export class CouriersService {
  private route = '/api/marketplace/courier'
  constructor(
    private http: HttpClient, 
    private auth: AuthenticationService, 
    private logging: LoggingService) { }
  
    search(event: LazyLoadEvent): Promise<any> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }
  
    get(id: number): Promise<CourierServiceResponse> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as CourierServiceResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    create(item: CourierServiceResponse): Promise<CourierServiceResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/create`, item, { headers: this.auth.header })
        .toPromise()
        .then(response => response as CourierServiceResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    update(coupon: CourierServiceResponse): Promise<CourierServiceResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/update`, coupon, { headers: this.auth.header })
        .toPromise()
        .then(response => response as CourierServiceResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    delete(id: string): Promise<any> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

    getPackageOption(id: number): Promise<PackageOptionResponse> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/package-option/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as PackageOptionResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    createPackageOption(item: PackageOptionResponse): Promise<PackageOptionResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/package-option/create`, item, { headers: this.auth.header })
        .toPromise()
        .then(response => response as PackageOptionResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    updatePackageOption(coupon: PackageOptionResponse): Promise<PackageOptionResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/package-option/update`, coupon, { headers: this.auth.header })
        .toPromise()
        .then(response => response as PackageOptionResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    deletePackageOption(id: string): Promise<any> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/package-option/delete/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/courier-services/couriers.service.ts